import React from 'react'
import { FlexboxGrid, Stack, Toggle } from 'rsuite'

const PSubM = () => {
  return (
    <>
      <b>Features</b>
      <FlexboxGrid>
        <FlexboxGrid.Item colspan={6}>
          <div
            style={{
              padding: '8px',
              width: '200px',
              background: 'aliceblue',
              borderRadius: '6px',
              margin: '4px'
            }}
          >
            <Stack justifyContent="space-between">
              <Toggle size="sm" />
              <p>Image Update</p>
            </Stack>
          </div>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item colspan={6}>
          <div
            style={{
              padding: '8px',
              width: '200px',
              background: 'aliceblue',
              borderRadius: '6px',
              margin: '4px'
            }}
          >
            <Stack justifyContent="space-between">
              <Toggle size="sm" />
              <p>Variant Update</p>
            </Stack>
          </div>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item colspan={6}>
          <div
            style={{
              padding: '8px',
              width: '200px',
              background: 'aliceblue',
              borderRadius: '6px',
              margin: '4px'
            }}
          >
            <Stack justifyContent="space-between">
              <Toggle size="sm" />
              <p>Manage Product</p>
            </Stack>
          </div>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item colspan={6}>
          <div
            style={{
              padding: '8px',
              width: '200px',
              background: 'aliceblue',
              borderRadius: '6px',
              margin: '4px'
            }}
          >
            <Stack justifyContent="space-between">
              <Toggle size="sm" />
              <p>Costing</p>
            </Stack>
          </div>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item colspan={6}>
          {' '}
          <div
            style={{
              padding: '8px',
              width: '200px',
              background: 'aliceblue',
              borderRadius: '6px',
              margin: '4px'
            }}
          >
            <Stack justifyContent="space-between">
              <Toggle size="sm" />
              <p>Smart Search</p>
            </Stack>
          </div>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item colspan={6}>
          <div
            style={{
              padding: '8px',
              width: '200px',
              background: 'aliceblue',
              borderRadius: '6px',
              margin: '4px'
            }}
          >
            <Stack justifyContent="space-between">
              <Toggle size="sm" />
              <p>Add bulk Product</p>
            </Stack>
          </div>
        </FlexboxGrid.Item>
      </FlexboxGrid>
    </>
  )
}

export default PSubM
